import React from 'react';
import { Star, Settings } from 'lucide-react';
import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameMonth, addMonths } from 'date-fns';

const MonthView = () => {
    const currentDate = new Date(2022, 1, 1); // February 2022 for the "Next Month" mockup
    const monthStart = startOfMonth(currentDate);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart, { weekStarts: 1 });
    const endDate = endOfWeek(monthEnd, { weekStarts: 1 });

    const days = eachDayOfInterval({ start: startDate, end: endDate });
    const weekDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

    const getEventsForDay = (day) => {
        const dayNum = parseInt(format(day, 'd'));
        // Mock data matching the screenshot
        if (dayNum === 1) return [<span key="1" className="event-block blue-text">Quotes</span>, <span key="2" className="event-block orange-text">Giveaway</span>];
        if (dayNum === 4) return [<span key="1" className="event-block orange-text">Giveaway</span>];
        if (dayNum === 8) return [<span key="1" className="event-block blue-text">Quotes</span>, <span key="2" className="event-block orange-text">Giveaway</span>];
        if (dayNum === 11) return [<span key="1" className="event-block green-text">Freebie</span>];
        if (dayNum === 13) return [<span key="1" className="event-block blue-text">Quotes</span>, <span key="2" className="event-block red-text">Reel</span>];
        if (dayNum === 15) return [<span key="1" className="event-block blue-text">Quotes</span>, <span key="2" className="event-block orange-text">Giveaway</span>];
        if (dayNum === 20) return [<span key="1" className="event-block red-text">Reel</span>];
        if (dayNum === 25) return [<span key="1" className="event-block blue-text">Quotes</span>, <span key="2" className="event-block green-text">Freebie</span>];
        if (dayNum === 29) return [<span key="1" className="event-block blue-text">Quotes</span>, <span key="2" className="event-block orange-text">Giveaway</span>];
        return [];
    };

    const getHighlightClass = (day) => {
        const dayNum = parseInt(format(day, 'd'));
        if (dayNum === 1 || dayNum === 11 || dayNum === 29) return 'highlight-red';
        if (dayNum === 13) return 'highlight-blue';
        if (dayNum === 15) return 'highlight-green';
        return '';
    };

    const hasAvatars = (day) => {
        const dayNum = parseInt(format(day, 'd'));
        return [1, 8, 11, 15, 20, 25, 30].includes(dayNum);
    };

    return (
        <div className="month-view-content">
            <div className="view-header">
                <h2 className="view-title">Next Month <span>| February 02</span></h2>
                <div className="view-actions">
                    <button className="action-btn"><Star size={16} /> Favorite</button>
                    <button className="action-btn"><Settings size={16} /> Setting</button>
                </div>
            </div>

            <div className="month-grid">
                {weekDays.map(day => (
                    <div key={day} className="grid-day-header">{day}</div>
                ))}
                
                {days.map((day, idx) => {
                    const isCurrentMonth = isSameMonth(day, monthStart);
                    const highlightClass = isCurrentMonth ? getHighlightClass(day) : '';
                    
                    return (
                        <div key={idx} className={`grid-cell ${!isCurrentMonth ? 'other-month' : ''} ${highlightClass}`}>
                            <span className="grid-date">{format(day, 'd')}</span>
                            
                            {isCurrentMonth && (
                                <>
                                    {hasAvatars(day) && (
                                        <div className="avatar-group">
                                            <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50&q=80" alt="u1" />
                                            <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&q=80" alt="u2" />
                                            <div className="avatar-count">+1</div>
                                        </div>
                                    )}
                                    {getEventsForDay(day)}
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MonthView;
